import { SvgHelp, SvgUndo, TextButton } from '@loomhq/lens';
import React, { Component } from 'react';
import { connect } from 'react-redux';

import { TRIMMING_SUPPORT_ARTICLE } from 'constants/routes';
import {
  patchTrimVideoCreator,
  updateTrimRangesCreator,
} from 'creators/trimming';

import ReturnToVideoButton from '../return-to-video-button';

import './styles.less';

class TrimFooter extends Component {
  static className = 'revert-to-original-button';

  render() {
    const { originalRanges, video } = this.props;
    const revertEnabledClass = originalRanges.length > 0 ? 'enabled' : '';

    return (
      <div className="trim-footer">
        <div className="left-section">
          <ReturnToVideoButton
            onLeave={this.props.onRevertClicked}
            video={video}
          />
        </div>
        <div className="middle-section">
          <div
            className={`${this.constructor.className} ${revertEnabledClass}`}
          >
            <TextButton
              icon={<SvgUndo />}
              isDisabled={originalRanges.length < 1}
              onClick={this.onRevertToOriginalClicked}
            >
              Revert to Original
            </TextButton>
          </div>
        </div>
        <div className="right-section">
          <a
            className="trim-help"
            href={TRIMMING_SUPPORT_ARTICLE}
            target="_blank"
            rel="noreferrer noopener"
          >
            <TextButton icon={<SvgHelp />}>Help Center</TextButton>
          </a>
        </div>
      </div>
    );
  }

  onRevertToOriginalClicked = async () => {
    const { video } = this.props;

    if (
      !window.confirm("Are you sure you'd like to delete all of your edits?")
    ) {
      return;
    }

    await this.props.updateTrimRangesCreator([]);
    await this.props.patchTrimVideoCreator(video, this.props.onRevertClicked);
  };
}

const mapStateToProps = state => {
  const { original_ranges: originalRanges } = state.trimming;

  return { originalRanges };
};

const mapDispatchToProps = dispatch => {
  return {
    patchTrimVideoCreator: (video, onFinish) =>
      dispatch(patchTrimVideoCreator(video, onFinish)),
    updateTrimRangesCreator: ranges =>
      dispatch(updateTrimRangesCreator(ranges)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(TrimFooter);
